import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cffa9a94&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=cffa9a94&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cffa9a94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cffa9a94')) {
      api.createRecord('cffa9a94', component.options)
    } else {
      api.reload('cffa9a94', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=cffa9a94&scoped=true", function () {
      api.rerender('cffa9a94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/towerControl/dashboard/index.vue"
export default component.exports